// extracted by css-extract-rspack-plugin
export default {"loading":"loading-yLgu1y"};